import React from 'react';

export default function TechViews({ activeView, onNavigate, onOpenModal, onShowToast }) {
  return (
    <>
        <div id="view-agents" className={`view-panel ${activeView === 'view-agents' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-robot" style={{"color":"var(--gold-light)"}}></i> GIÁM SÁT ĐỘI NGŨ AI AGENT &amp; THƯ VIỆN SKILL</h2>
                    <p>Theo Dõi Hiệu Suất BOT Ban Trợ Lý, BOT Dự Án, BOT Trưởng Phòng &amp; Nhân Viên Agent</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div className="workflow-step-card">
                <h3 style={{"color":"white","fontSize":"14px","marginBottom":"8px"}}>Thư Viện AI Skills Vận Hành Thực Tế</h3>
                <p style={{"color":"var(--text-muted)","fontSize":"12px"}}>Đã nạp 5 AI Skills chuẩn hóa vào OpenClaw Router: <code>skill-video-batch-gen</code>, <code>skill-po-split-ncc</code>, <code>skill-cccd-ocr-vision</code>, <code>skill-batch-shipping-label</code>, <code>skill-commission-calc</code>.</p>
            </div>
        </div>

        <div id="view-datasources" className={`view-panel ${activeView === 'view-datasources' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-database" style={{"color":"var(--gold-light)"}}></i> NGUỒN DỮ LIỆU &amp; MA TRẬN PHÂN QUYỀN RBAC</h2>
                    <p>CSDL Nội Bộ chothuoc247.vn, OpenClaw Memory Engine &amp; Lark Base Sync</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div className="workflow-step-card">
                <h3 style={{"color":"white","fontSize":"14px","marginBottom":"8px"}}>CSDL Nội Bộ chothuoc247.vn (PostgreSQL Nội Bộ)</h3>
                <p style={{"color":"var(--text-muted)","fontSize":"12px"}}>Kết nối trực tiếp thời gian thực, chi phí trung gian = 0 VNĐ, bảo mật dữ liệu tuyệt đối.</p>
            </div>
        </div>

        <div id="view-outputs" className={`view-panel ${activeView === 'view-outputs' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-box-archive" style={{"color":"var(--gold-light)"}}></i> KHO LƯU TRỮ ĐẦU RA (OUTPUT REPOSITORY)</h2>
                    <p>Quản Trị Đầu Ra Được Gắn Mã Băm, Phiên Bản &amp; Trạng Thái Nghiệm Thu</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div className="workflow-step-card">
                <h3 style={{"color":"white","fontSize":"14px","marginBottom":"8px"}}>Danh Mục Đầu Ra Đã Bàn Giao</h3>
                <p style={{"color":"var(--text-muted)","fontSize":"12px"}}>OUT-MKT-001 (Video Batch v1.2), OUT-PROC-004 (Bảng phân bổ PO v1.0), OUT-HR-002 (Bảng hoa hồng v2.0), OUT-LOG-009 (PDF Tem nhãn in nhiệt 85 đơn).</p>
            </div>
        </div>

        <div id="view-audit" className={`view-panel ${activeView === 'view-audit' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-clock-rotate-left" style={{"color":"var(--gold-light)"}}></i> AUDIT TRAIL &amp; TRÌNH GIẢ LẬP ROI TƯƠNG TÁC</h2>
                    <p>Nhật Ký Hệ Thống Thời Gian Thực &amp; Giả Lập Số Giờ Tiết Kiệm</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div className="workflow-step-card">
                <h3 style={{"color":"white","fontSize":"14px","marginBottom":"8px"}}>Hiệu Quả Ước Tính Toàn Hệ Thống</h3>
                <p style={{"color":"var(--text-muted)","fontSize":"12px"}}>Tiết kiệm ước tính: <strong>342 Giờ lao động / Tháng</strong> (~2.1 Công nhân sự) • Giá trị tài chính tạo ra: <strong>~22.230.000 đ/tháng</strong> • Chi phí API: <strong>~150.000 đ</strong>.</p>
            </div>
        </div>

    </>
  );
}
